var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticStyle:{"text-align":"center"}},[_vm._v("Loading...")]):_vm._e(),_c('canvas',{staticClass:"text-center mt-2",attrs:{"id":"the-canvas"}})])}
var staticRenderFns = []

export { render, staticRenderFns }